import { Heading, HeadingProps } from '@chakra-ui/react';
import React from 'react';

import { CmText } from '@/components/uiParts/Text/CmText';

type Props = {
  isRequired?: boolean;
} & HeadingProps;

export const CmHeading: React.FC<Props> = ({
  children,
  as = 'h4',
  size = 'md',
  isRequired = false,
  ...rest
}) => {
  return (
    // @ts-ignore TS2590
    <Heading {...{ as, size, ...rest }}>
      {children}
      {isRequired && (
        <CmText as="span" color="red" fontSize="14px" verticalAlign="super">
          *
        </CmText>
      )}
    </Heading>
  );
};
